import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { getConsent, onConsentChange } from "@/lib/consent";
import { initializeAnalytics, analyticsAllowed, recordPage, googleEvent, markInteraction, flushAnalytics } from "@/lib/analytics-tracker";

export function GtmLoader() {
  const router = useRouter();
  useEffect(() => {
    let disposed = false;
    const interaction = () => { markInteraction(); maybeGoogle(); };
    const maybeGoogle = () => {
      if (!analyticsAllowed() || getConsent() !== "granted") return;
      // SSR bootstrap no longer injects Google: consent and role exclusion resolved here.
      const w = window as Window & { dataLayer?: unknown[] };
      w.dataLayer ??= [];
      const state = { analytics_storage: "granted", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" };
      if (document.getElementById("gtm-script")) {
        w.dataLayer.push(["consent", "update", state], { event: "consent_update", "gtag.consent.update": state });
        return;
      }
      w.dataLayer.push(["consent", "default", { ...state, analytics_storage: "denied" }], ["consent", "update", state], { event: "consent_update", "gtag.consent.update": state });
      const script = document.createElement("script");
      script.id = "gtm-script"; script.async = true;
      script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-KXZVDHQX";
      w.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      document.head.appendChild(script);
      googleEvent("page_view");
    };
    void initializeAnalytics().then(ok => {
      if (!ok || disposed) return;
      recordPage(window.location.pathname);
    });
    const off = router.subscribe("onResolved", () => recordPage(window.location.pathname));
    const consentOff = onConsentChange(value => {
      (window as unknown as Record<string, unknown>)["ga-disable-G-Z4W3VN12LN"] = value !== "granted";
      if (value === "granted") maybeGoogle();
      else {
        const w = window as Window & { dataLayer?: unknown[] };
        w.dataLayer?.push(["consent", "update", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" }]);
        // Stop an already running container without any cookieless pings.
        (window as unknown as Record<string, unknown>)["ga-disable-G-Z4W3VN12LN"] = true;
      }
      if (value === "granted") (window as unknown as Record<string, unknown>)["ga-disable-G-Z4W3VN12LN"] = false;
    });
    const events = ["pointerdown", "keydown", "touchstart", "scroll"] as const;
    events.forEach(e => window.addEventListener(e, interaction, { passive: true }));
    window.addEventListener("pagehide", flushAnalytics);
    return () => { disposed = true; off(); consentOff(); events.forEach(e => window.removeEventListener(e, interaction)); window.removeEventListener("pagehide", flushAnalytics); };
  }, [router]);
  return null;
}
